import { FieldValidation } from '../../core/domain/transaction/fieldValidation';

export const maxLength = (length: number): FieldValidation => (value) => {
	return value.length <= length;
};
